/* The Pet Standard — custom PDP behaviour (pairs with sections/pj-product.liquid).
   Variant switching, Subscribe & Save with bag-weight frequency recommendation,
   qty, thumbnails, dynamic ATC label. Wired to real Shopify variants + selling plans. */
(function () {
  var root = document.querySelector('[data-pj-pdp]');
  if (!root) return;
  var dataEl = root.querySelector('[data-pj-pdata]');
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var cur = data.currency || '$';
  var variants = data.variants || [];
  if (!variants.length) return;
  var perDollar = parseFloat(root.dataset.perdollar) || 1;
  // Species-aware feeding rate (g/day) for the bag-lasts-N-weeks subscribe recommendation.
  // Uses the PRODUCT's species (a cat food page does cat maths no matter who's browsing) and the
  // shopper's pet size when their active pet matches; non-dog/cat products skip the estimate
  // entirely rather than pretend dog maths applies.
  var PRODUCT_SPECIES = (root.dataset.species || '').toLowerCase();
  var FEED_RATES = { dog: { small: 120, medium: 250, large: 350 }, cat: { small: 45, medium: 60, large: 75 } };
  function dailyGrams() {
    var t = FEED_RATES[PRODUCT_SPECIES];
    if (!t) return null;
    var size = 'medium';
    try {
      var pet = window.PJ && window.PJ.getPet && window.PJ.getPet();
      if (pet && pet.species && String(pet.species).toLowerCase() === PRODUCT_SPECIES && pet.size) size = String(pet.size).toLowerCase();
    } catch (e) {}
    return t[size] || t.medium;
  }
  var $ = function (s) { return root.querySelector(s); };

  function money(cents) { return cur + (cents / 100).toFixed(2); }
  function vget(id) { for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i]; return variants[0]; }
  function cleanName(n) { return (n || '').replace(/^deliver(ed)?\s*/i, '').replace(/\s*,?\s*\d+%\s*off.*$/i, '').trim(); }
  function shortName(n) { return cleanName(n).replace(/^every\s*/i, '').trim() || cleanName(n); }

  function planWeeks(name) {
    name = (name || '').toLowerCase(); var m;
    m = name.match(/(\d+)\s*month/); if (m) return parseInt(m[1], 10) * 4.345;
    if (/month/.test(name)) return 4.345;
    m = name.match(/(\d+)\s*week/); if (m) return parseInt(m[1], 10);
    if (/week/.test(name)) return 1;
    m = name.match(/(\d+)\s*day/); if (m) return parseInt(m[1], 10) / 7;
    return null;
  }
  function bagWeeks(v) {
    var m = (v.title || '').match(/([\d.]+)\s*kg/i);
    var kg = m ? parseFloat(m[1]) : 0;
    if (!kg) return null;
    var g = dailyGrams();
    if (!g) return null;
    return Math.round(kg * 1000 / g / 7);
  }
  function recPlan(v) {
    if (!v.plans || !v.plans.length) return null;
    var bw = bagWeeks(v);
    if (bw == null) return v.plans[0];
    var best = v.plans[0], bestD = Infinity;
    v.plans.forEach(function (p) { var w = planWeeks(p.name); if (w == null) return; var d = Math.abs(w - bw); if (d < bestD) { bestD = d; best = p; } });
    return best;
  }

  var state = { vid: parseInt($('[data-pj-vid]').value, 10), mode: 'once', planId: null, qty: 1 };

  function renderAtcLabel(v) {
    var lbl = $('[data-pj-atc-label]'); if (!lbl) return;
    if (!v.available) { lbl.textContent = 'Sold out'; return; }
    if (state.mode === 'sub' && v.plans && v.plans.length) {
      var sel = null; v.plans.forEach(function (p) { if (p.id === state.planId) sel = p; });
      sel = sel || recPlan(v);
      lbl.textContent = 'Subscribe — ' + money((sel ? sel.price : v.price) * state.qty);   // reflect the chosen quantity, like the one-time branch
    } else {
      lbl.textContent = 'Add to cart — ' + money(v.price * state.qty);
    }
  }

  function renderSub(v) {
    var sub = $('[data-pj-sub]'); if (!sub) return;
    if (!v.plans || !v.plans.length) {
      // Variant has no subscription plans: hide the sub UI AND clear any stale plan state/input,
      // otherwise a selling_plan left over from a previous variant gets submitted on the native
      // (non-AJAX) form fallback for a variant that doesn't offer it.
      sub.style.display = 'none';
      state.mode = 'once'; state.planId = null;
      var pIn = $('[data-pj-plan]'); if (pIn) pIn.value = '';
      return;
    }
    sub.style.display = '';
    sub.dataset.mode = state.mode;
    var once = $('[data-pj-once-price]'); if (once) once.textContent = money(v.price);
    var rec = recPlan(v);
    var sel = null; v.plans.forEach(function (p) { if (p.id === state.planId) sel = p; });
    sel = sel || rec;
    state.planId = sel ? sel.id : null;
    var sp = $('[data-pj-sub-price]'); if (sp && sel) sp.textContent = money(sel.price);
    var sv = $('[data-pj-sub-save]');                                   // say the % saving out loud — no mental math between the two prices
    if (sv) {
      var pct = (sel && v.price > 0) ? Math.round((1 - sel.price / v.price) * 100) : 0;
      if (pct > 0) { sv.textContent = 'SAVE ' + pct + '%'; sv.hidden = false; } else { sv.hidden = true; }
    }
    var fl = $('[data-pj-sub-freqlabel]'); if (fl && sel) fl.textContent = 'Delivered ' + cleanName(sel.name) + ' · skip anytime';

    var grid = $('[data-pj-freq-grid]');
    if (grid) {
      grid.innerHTML = '';
      v.plans.forEach(function (p) {
        var isSel = sel && p.id === sel.id, isRec = rec && p.id === rec.id;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pj-freq-tile' + (isSel ? ' is-sel' : '') + (isRec && !isSel ? ' is-rec' : '');
        b.innerHTML = '<span class="pj-freq-tile__lbl">' + shortName(p.name) + '</span>' + (isRec ? '<span class="pj-freq-tile__rec">RECOMMENDED</span>' : '');
        b.addEventListener('click', function () { state.planId = p.id; state.mode = 'sub'; render(); });
        grid.appendChild(b);
      });
    }
    var note = $('[data-pj-freq-note]');
    if (note) {
      var bw = bagWeeks(v);
      var g = dailyGrams();
      var spWord = PRODUCT_SPECIES === 'cat' ? 'cat' : 'dog';
      if (bw && sel && g) note.textContent = 'At a typical adult ' + spWord + '’s feeding rate (~' + g + 'g a day) a ' + v.title + ' bag lasts about ' + bw + ' weeks — so ' + cleanName(sel.name) + ' keeps them topped up without overstocking.';
      else note.textContent = 'Set how often we send it — skip, pause or cancel anytime.';
    }
    var freqPanel = $('[data-pj-freq]'), planInput = $('[data-pj-plan]');
    if (freqPanel) freqPanel.hidden = false;                                       // permanently expanded
    if (planInput) planInput.value = (state.mode === 'sub' && sel) ? sel.id : '';   // only submit a plan when subscribing
  }

  // Paws earn for the shopper's CURRENT tier (Companion 1x default; the real tier is
  // supplied by pj-base.js once the Paws proxy loads, for signed-in members). Rounded up.
  function renderEarn(v) {
    var el = $('[data-pj-paws-earn]'); if (!el) return;
    var dollars = v.price / 100 * perDollar;
    var mult = (typeof window.__pjTierMult === 'number' && window.__pjTierMult > 0) ? window.__pjTierMult : 1;
    var val = el.querySelector('[data-pj-paws-val]'); if (val) val.textContent = Math.ceil(dollars * mult);
    var note = el.querySelector('[data-pj-paws-tier-note]');
    if (note) note.textContent = window.__pjTierName ? (' as a ' + window.__pjTierName) : '';
  }

  function render() {
    clearAtcError();                                                   // stale add-to-cart error must not survive a variant/qty change
    var v = vget(state.vid);
    root.querySelectorAll('[data-pj-variant]').forEach(function (b) { b.classList.toggle('is-active', parseInt(b.dataset.vid, 10) === state.vid); });
    $('[data-pj-vid]').value = v.id;
    var vl = $('[data-pj-vlabel]'); if (vl) vl.textContent = v.title;
    $('[data-pj-price]').textContent = money(v.price);
    var comp = $('[data-pj-compare]'), save = $('[data-pj-save]');
    if (v.compare > v.price) { if (comp) { comp.hidden = false; comp.textContent = money(v.compare); } if (save) { save.hidden = false; save.textContent = 'Save ' + money(v.compare - v.price); } }
    else { if (comp) comp.hidden = true; if (save) save.hidden = true; }
    var uw = $('[data-pj-unit]');
    if (uw && v.unit) { uw.hidden = false; var uv = $('[data-pj-unit-val]'); if (uv) uv.textContent = money(v.unit) + '/' + (v.unitlabel || ''); }
    else if (uw) { uw.hidden = true; }
    var ap = $('[data-pj-afterpay]'); if (ap) ap.textContent = money(Math.round(v.price / 4));
    renderEarn(v);
    var atc = $('[data-pj-atc]'); if (atc) atc.disabled = !v.available;
    var bisBox = $('[data-pj-bis]'); if (bisBox) bisBox.hidden = v.available;
    if (v.img) {
      var mi = $('[data-pj-main-img]'); if (mi) setMainImg(mi, v.img);
      // keep the highlighted thumbnail in sync with the shown image
      root.querySelectorAll('[data-pj-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.dataset.full === v.img); });
    }
    renderSub(v);
    renderAtcLabel(v);
  }

  root.querySelectorAll('[data-pj-variant]').forEach(function (b) {
    // Every variant is clickable, incl. sold-out ones — selecting a sold-out variant reveals the
    // back-in-stock form (render() unhides [data-pj-bis] and disables the ATC when !available).
    b.addEventListener('click', function () { state.vid = parseInt(b.dataset.vid, 10); state.planId = null; render(); });
  });
  root.querySelectorAll('.pj-sub__card').forEach(function (c) {
    c.addEventListener('click', function (e) { e.preventDefault(); state.mode = c.dataset.pjMode; render(); });
  });
  var dec = $('[data-pj-qty-dec]'), inc = $('[data-pj-qty-inc]'), qd = $('[data-pj-qty-display]'), qi = $('[data-pj-qty-input]');
  function setQty(n) { state.qty = Math.max(1, n); if (qd) qd.textContent = state.qty; if (qi) qi.value = state.qty; renderAtcLabel(vget(state.vid)); }
  if (dec) dec.addEventListener('click', function () { setQty(state.qty - 1); });
  if (inc) inc.addEventListener('click', function () { setQty(state.qty + 1); });
  // The server-rendered main image ships a responsive srcset (SEO/LCP). JS swaps only
  // have a single 900px URL, so drop srcset/sizes before setting src — otherwise the
  // browser keeps rendering the stale srcset candidate and the gallery looks frozen.
  function setMainImg(mi, url) {
    // No-op when the URL is unchanged (e.g. the init render()) — stripping srcset there would
    // force a duplicate 900px download and kill the server-rendered responsive/LCP behavior.
    if (mi.getAttribute('src') === url) return;
    mi.removeAttribute('srcset'); mi.removeAttribute('sizes'); mi.src = url;
  }

  root.querySelectorAll('[data-pj-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var mi = $('[data-pj-main-img]'); if (mi && t.dataset.full) setMainImg(mi, t.dataset.full);
      root.querySelectorAll('[data-pj-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  // Inline add-to-cart error (out-of-stock / over-available-qty). Self-styled so it
  // shows without a CSS dependency; created lazily just after the ATC button.
  function showAtcError(msg) {
    var atc = $('[data-pj-atc]'); if (!atc) return;
    var el = root.querySelector('[data-pj-atc-err]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-pj-atc-err', ''); el.setAttribute('role', 'alert');
      el.style.cssText = 'margin-top:8px;color:#B42318;font-size:13px;font-weight:600;line-height:1.35;';
      var anchor = atc.closest('.pj-buy-row') || atc;
      (anchor.parentNode || root).insertBefore(el, anchor.nextSibling);
    }
    el.textContent = msg; el.style.display = 'block';
  }
  function clearAtcError() { var el = root.querySelector('[data-pj-atc-err]'); if (el) el.style.display = 'none'; }

  // AJAX add-to-cart → open Hyper's native cart drawer (via window.PJ.addToCart),
  // instead of a full-page POST to /cart. Falls back to the native form submit if
  // the engine isn't available or the request fails.
  var form = $('form') || root.querySelector('form');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!window.PJ || typeof window.PJ.addToCart !== 'function') return; // native POST
      var v = vget(state.vid);
      if (!v.available) { e.preventDefault(); return; }
      e.preventDefault();
      var atc = $('[data-pj-atc]');
      var plan = (state.mode === 'sub' && state.planId) ? state.planId : null;
      if (atc) atc.disabled = true;
      window.PJ.addToCart(state.vid, state.qty, plan).then(function () {
        if (atc) atc.disabled = false;
        clearAtcError();
      }).catch(function (err) {
        if (atc) atc.disabled = false;
        if (err && err.cartError) {
          // Shopify rejected the add (out of stock / over available qty) — surface it inline; don't navigate.
          showAtcError(err.cartError.description || err.cartError.message || 'Could not add to cart');
        } else {
          form.submit(); // network/engine failure → native fallback (submit() does not re-fire this handler)
        }
      });
    });
  }

  // Back-in-stock signup → Klaviyo client back-in-stock API. Subscribes the email to
  // the selected (sold-out) variant and tags the shopper's loyalty tier so the
  // First-Dibs flow can branch on it. (first_dibs itself is set server-side on redemption.)
  (function () {
    var box = root.querySelector('[data-pj-bis]'); if (!box) return;
    var companyId = root.dataset.klaviyo || '';
    var emailEl = box.querySelector('[data-pj-bis-email]');
    var btn = box.querySelector('[data-pj-bis-submit]');
    var msg = box.querySelector('[data-pj-bis-msg]');
    var btnLabel = btn ? btn.textContent : 'Notify me';
    function showMsg(text, kind) {
      if (!msg) return;
      msg.hidden = false; msg.textContent = text;
      msg.className = 'pj-bis__msg' + (kind === 'ok' ? ' is-ok' : kind === 'err' ? ' is-err' : '');
    }
    function submit() {
      var email = (emailEl && emailEl.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { showMsg('Please enter a valid email address.', 'err'); return; }
      if (!companyId) { showMsg('Restock alerts aren’t switched on yet.', 'err'); return; }
      var v = vget(state.vid);
      if (btn) { btn.disabled = true; btn.textContent = '…'; }
      // Best-effort: tag the shopper's loyalty tier on their profile so the First-Dibs
      // back-in-stock flow can branch on it (the back-in-stock endpoint itself rejects
      // profile properties, so this is a separate fire-and-forget identify).
      function tagTier() {
        if (!window.__pjTierName) return;
        try {
          fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(companyId), {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
            body: JSON.stringify({ data: { type: 'profile', attributes: { email: email, properties: { pj_tier: window.__pjTierName } } } })
          });
        } catch (e) {}
      }
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + v.id } } }
          }
        })
      }).then(function (r) {
        if (btn) { btn.disabled = false; btn.textContent = btnLabel; }
        if (r.ok) { tagTier(); showMsg(box.dataset.success || 'You’re on the list — we’ll email you.', 'ok'); if (emailEl) emailEl.value = ''; }
        else { showMsg('Something went wrong — please try again.', 'err'); }
      }).catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = btnLabel; }
        showMsg('Network error — please try again.', 'err');
      });
    }
    if (btn) btn.addEventListener('click', submit);
    if (emailEl) emailEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });
  })();

  // Smart-sticky buy box: follow the scroll DIRECTION so a box taller than the screen reveals the Add to
  // Cart (bottom) as you scroll down and its top as you scroll up — one clean single scroll, no internal
  // scrollbar. Boxes that fit just pin to the top. Disabled on mobile (the box is static there).
  (function () {
    var bb = root.querySelector('.pj-bb'); if (!bb) return;
    // Match the CSS resting offset (real Hyper header height + 12px) instead of a hardcoded 96.
    var _hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
    var TOP = (_hh > 0 ? _hh : 96) + 12, BOT = 16, mq = window.matchMedia('(max-width: 989px)');
    var lastY = window.pageYOffset, curTop = TOP, raf = 0;
    function apply() {
      raf = 0;
      if (mq.matches) { bb.style.top = ''; lastY = window.pageYOffset; return; }        // mobile: static (CSS)
      var vh = window.innerHeight, bh = bb.offsetHeight, y = window.pageYOffset;
      if (bh <= vh - TOP - BOT) { curTop = TOP; bb.style.top = TOP + 'px'; lastY = y; return; }  // fits → pin top
      var dy = y - lastY; lastY = y;
      var minTop = vh - bh - BOT;                                      // negative — box taller than the viewport
      curTop = Math.max(minTop, Math.min(TOP, curTop - dy));           // scroll down → box moves up; up → down
      bb.style.top = curTop + 'px';
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(apply); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { lastY = window.pageYOffset; apply(); });
    apply();
  })();

  document.addEventListener('pj:paws-tier', function () { renderEarn(vget(state.vid)); });
  render();
})();
